import React from "react";
import LayoutPortfolio from "../../layouts/LayoutPortfolio";
import AboutMePortfolio from "../../templates/portfolio/AboutMePortfolio";
import HeroPortfolio from "../../templates/portfolio/HeroPortfolio";
import ProjectsPortfolio from "../../templates/portfolio/ProjectsPortfolio";
import ServicesPortfolio from "../../templates/portfolio/ServicesPortfolio";

const Portfolio = () => {
	return (
		<LayoutPortfolio>
			<HeroPortfolio />
			{/* <AboutMePortfolio /> */}
			<ServicesPortfolio />
			<ProjectsPortfolio />
		</LayoutPortfolio>
	);
};

export default Portfolio;
